import type { ReactNode } from 'react'
import { alertClass } from '../../lib/ui'

type Props = {
  kind: 'err' | 'warn'
  children: ReactNode
}

export function Alert({ kind, children }: Props) {
  return <div className={alertClass(kind)}>{children}</div>
}
